import { render } from "./GovernanceScoreboardWidget.vue?vue&type=template&id=c9800492&scoped=true"
import script from "./GovernanceScoreboardWidget.vue?vue&type=script&lang=js"
export * from "./GovernanceScoreboardWidget.vue?vue&type=script&lang=js"

import "./GovernanceScoreboardWidget.vue?vue&type=style&index=0&id=c9800492&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9800492"]])

export default __exports__